module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('feedback-modal', {
    ref: "feedbackModal",
    staticClass: "target-modal",
    on: {
      "dismiss": _vm.emitDismiss
    }
  }, [_c('div', {
    staticClass: "target-modal__message"
  }, [_vm._v(_vm._s(_vm.message))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e471fec","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/feedbackModal/ErrorModal.vue
// module id = 2088
// module chunks = 0